import React from 'react';
import Card from '../common/Card';
import Badge from '../common/Badge';
import SafeIcon from '../../common/SafeIcon';
import { motion } from 'framer-motion';

const AlertsView = ({ alerts, queueItem }) => {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="flex justify-between items-end mb-6">
        <div>
          <h2 className="text-2xl font-bold text-white tracking-tight">Reorder Alerts</h2>
          <p className="text-gray-400 mt-1">Items currently below minimum stock threshold.</p>
        </div>
        <div className="text-sm font-mono text-sp-alert flex items-center gap-2">
          <SafeIcon name="AlertTriangle" />
          {alerts.length} Critical Items
        </div>
      </div>

      <Card className="overflow-x-auto">
        <table className="w-full text-left border-collapse">
          <thead>
            <tr className="border-b border-sp-gray-800 bg-sp-gray-800/30 text-xs uppercase tracking-wider text-gray-500 font-mono">
              <th className="p-4 font-medium">SKU / Product</th>
              <th className="p-4 font-medium">Status</th>
              <th className="p-4 font-medium">Current Stock</th>
              <th className="p-4 font-medium">Min Level</th>
              <th className="p-4 font-medium">Deficit</th>
              <th className="p-4 font-medium text-right">Action</th>
            </tr>
          </thead>
          <tbody className="text-sm">
            {alerts.length === 0 ? (
              <tr>
                <td colSpan="6" className="p-8 text-center text-gray-500 font-mono">
                  No active alerts. Inventory levels optimal.
                </td>
              </tr>
            ) : (
              alerts.map((item, idx) => {
                const deficit = item.minStock - item.stock;
                const isStockout = item.stock === 0;
                
                return (
                  <motion.tr 
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: idx * 0.05 }}
                    key={item.id} 
                    className="border-b border-sp-gray-800 hover:bg-sp-gray-800/20 transition-colors"
                  >
                    <td className="p-4">
                      <div className="font-mono text-gray-200">{item.sku}</div>
                      <div className="text-xs text-gray-500 mt-0.5">{item.name}</div>
                    </td>
                    <td className="p-4">
                      <Badge variant={isStockout ? 'alert' : 'default'} className={!isStockout ? 'border-orange-500/30 text-orange-400 bg-orange-500/10' : ''}>
                        {isStockout ? 'STOCKOUT' : 'LOW STOCK'}
                      </Badge>
                    </td>
                    <td className="p-4 font-mono font-bold text-white">
                      {item.stock}
                    </td>
                    <td className="p-4 font-mono text-gray-400">
                      {item.minStock}
                    </td>
                    <td className="p-4 font-mono text-sp-alert">
                      -{deficit}
                    </td>
                    <td className="p-4 text-right">
                      <button 
                        onClick={() => queueItem(item)}
                        className="bg-sp-lime/10 text-sp-lime border border-sp-lime/30 hover:bg-sp-lime hover:text-sp-black px-3 py-1.5 rounded text-xs font-mono font-bold transition-all shadow-[0_0_10px_rgba(204,255,0,0.1)] hover:shadow-neon"
                      >
                        Queue Reorder
                      </button>
                    </td>
                  </motion.tr>
                );
              })
            )}
          </tbody>
        </table>
      </Card>
    </motion.div>
  );
};

export default AlertsView;